export const getColumns = (isAdministration) => [
  {
    propName: 'isTaken',
    label: 'Обработка',
    aline: 'center',
    textAlign: 'center',
    width: '150px',
  },
  {
    propName: 'status',
    label: 'Статус',
    aline: 'left',
    textAlign: 'left',
  },
  {
    propName: 'financialSourceId',
    label: 'Оплата',
    sort: 'financial-source',
    handleClick: 'financial-source',
  },
  {
    propName: 'id',
    label: 'Номер заявки',
    sort: 'id',
    handleClick: 'id',
    aline: 'left',
    textAlign: 'left',
  },
  {
    propName: 'created',
    label: 'Дата создания',
    sort: 'created',
    handleClick: 'created',
    aline: 'center',
  },
  {
    propName: 'fullName',
    label: 'ФИО',
    sort: isAdministration ? null : 'fullname',
    handleClick: isAdministration ? null : 'fullname',
  },
  {
    propName: 'address',
    label: 'Адрес',
    sort: isAdministration ? null : 'locality',
    handleClick: isAdministration ? null : 'locality',
  },
  {
    propName: 'phone',
    label: isAdministration ? 'Телефон' : 'Номер телефона',
    aline: 'left',
  },
  {
    propName: 'categories',
    label: 'Льготная категория',
    aline: 'left',
    textAlign: 'left',
    width: '100px',
  },
]
